import { render, staticRenderFns } from "./ViewShift.vue?vue&type=template&id=9a2bd7f0&scoped=true&"
import script from "./ViewShift.vue?vue&type=script&lang=js&"
export * from "./ViewShift.vue?vue&type=script&lang=js&"
import style0 from "./ViewShift.vue?vue&type=style&index=0&id=9a2bd7f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2bd7f0",
  null
  
)

export default component.exports